import { RSAA } from 'redux-api-middleware';
import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/tags/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/tags/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/tags/LOAD_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadTags() {
  return {
    [RSAA]: {
      ...api.getTags(),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
      bailout: store => store.tags && store.tags.data.length > 1,
    },
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  error: '',
  data: [],
};

export default function tagsReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.items,
        error: null,
      };
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    default:
      return state;
  }
}

// ------------------------------------
// Selectors
// ------------------------------------

export function getTagName(globalState, tagSeoName) {
  const tag = globalState.tags.data.find(tag => tag.seoName === tagSeoName);
  return (tag && tag.name) || '';
}
